import { AuditActions } from 'src/types';

// eslint-disable-next-line complexity
export const getAuditLogIcon = (type: string, completed: boolean) => {
  if (!completed) {
    return 'uil uil-exclamation-octagon';
  }

  switch (type) {
    case AuditActions.CREATE_CASE:
    case AuditActions.SUBMIT_REPORT:
    case AuditActions.CREATE_DRAFT:
    case AuditActions.PUBLIC_SUBMIT_REPORT:
      return 'uil uil-file-plus';

    case AuditActions.IMPORT_CASE:
      return 'uil uil-file-upload';

    case AuditActions.VIEW_CASE:
      return 'uil uil-folder-open';

    case AuditActions.ADD_CASE_CATEGORY:
    case AuditActions.DELETE_CASE_CATEGORY:
    case AuditActions.INHERIT_CASE_CATEGORY:
    case AuditActions.CHANGE_DETERMINED_CATEGORY:
      return 'uil uil-file-edit-alt';

    case AuditActions.CHANGE_CASE_LEAD:
    case AuditActions.CHANGE_REPORT_ASSIGNEE:
      return 'uil uil-users-alt';

    case AuditActions.CREATE_CASE_DOCUMENT:
    case AuditActions.CREATE_CASE_DOCUMENT_ATTACHMENT:
    case AuditActions.CREATE_REPORT_NOTE:
    case AuditActions.DELETE_CASE_DOCUMENTS:
    case AuditActions.DELETE_CASE_DOCUMENT_ATTACHMENT:
    case AuditActions.DELETE_REPORT_NOTE:
    case AuditActions.UPDATE_CASE_DOCUMENT:
    case AuditActions.VIEW_CASE_DOCUMENT:
    case AuditActions.VIEW_CASE_DOCUMENT_ATTACHMENT:
      return 'uil uil-layer-group';

    case AuditActions.CHANGE_REPORT_SUBSTANTIATION:
      return 'uil uil-sliders-v-alt';

    case AuditActions.CREATE_MESSAGE:
    case AuditActions.VIEW_REPORT_MESSAGES:
      return 'uil uil-comment-alt-message';

    case AuditActions.EXPORT_REPORT:
      return 'uil uil-file-download';

    case AuditActions.VIEW_REPORT_EVIDENCE:
    case AuditActions.GET_REPORT_EVIDENCE:
    case AuditActions.TRANSLATE_REPORT:
      return 'uil uil-copy';

    case AuditActions.UPDATE_REPORT:
    case AuditActions.CHANGE_CASE_STATUS:
    case AuditActions.CHANGE_REPORT_STATUS:
    case AuditActions.UPDATE_CASE_TITLE:
    case AuditActions.UPDATE_REPORT_SUBMITTED_AT_DATE:
    case AuditActions.UPDATE_CASE_COMPANY_CREATED_AT_DATE:
    case AuditActions.UPDATE_CASE_READ_AT_DATE:
    case AuditActions.UPDATE_CASE_INVESTIGATING_AT_DATE:
    case AuditActions.UPDATE_CASE_CLOSED_AT_DATE:
    case AuditActions.ADD_EXTERNAL_OFFENDER:
    case AuditActions.ADD_INTERNAL_OFFENDER:
    case AuditActions.LINK_INTERNAL_OFFENDER:
    case AuditActions.UPDATE_CASE_COUNTRY_REGION:
    case AuditActions.UPDATE_CASE_DESCRIPTION:
    case AuditActions.UPDATE_REPORT_RELATIONSHIP_TO_ORGANISATION:
      return 'uil uil-edit-alt';

    case AuditActions.RETURNED_DEFAULT_ASSIGNEE:
    case AuditActions.RETURNED_RANDOM_ASSIGNEE:
    case AuditActions.RETURNED_ROUTING_ASSIGNEE:
      return 'uil uil-code-branch';

    case AuditActions.INVITE_TO_CASE:
      return 'uil uil-user-plus';

    case AuditActions.REMOVE_FROM_CASE:
      return 'uil uil-user-minus';

    case AuditActions.ADD_REPORT_UPLOADS_POST_SUBMISSION:
      return 'uil uil-file-upload-alt';

    case AuditActions.ADD_CASE_TAG:
    case AuditActions.REMOVE_CASE_TAG:
      return 'uil uil-label-alt';

    case AuditActions.DATA_SANITISATION_EVIDENCE:
    case AuditActions.DATA_SANITISATION_MESSAGES:
    case AuditActions.DATA_SANITISATION_NAMED_OFFENDERS:
    case AuditActions.DATA_SANITISATION_REPORT_DETAILS:
    case AuditActions.DATA_SANITISATION_REPORTER:
    case AuditActions.DATA_SANITISATION_REPORTER_NOTE:
      return 'uil uil-trash-alt';

    case AuditActions.CREATE_CASE_LINK:
      return 'uil uil-link';

    case AuditActions.DELETE_CASE_LINK:
      return 'uil uil-link-broken';

    default:
      return 'uil uil-check';
  }
};
